(() => {
  const SLICES_COLLECTION = 'slices-flavors';

  // ✅ Storefront Variant IDs (confirmed)
  const SLICES_BOX_4_VARIANT_ID  = 53587361399114;
  const SLICES_BOX_6_VARIANT_ID  = 53587368378698;
  const SLICES_BOX_12_VARIANT_ID = 53587371262282;

  const LIMIT_DEFAULT = 6;

  const $ = (s) => document.querySelector(s);

  const el = (tag, attrs = {}, children = []) => {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === 'class') n.className = v;
      else if (k === 'html') n.innerHTML = v;
      else n.setAttribute(k, v);
    });
    children.forEach((c) => n.appendChild(c));
    return n;
  };

  const getBoxLimit = () => {
    const p = new URLSearchParams(location.search);
    const raw = parseInt(p.get('box') || '', 10);
    const allowed = [4, 6, 12];
    return allowed.includes(raw) ? raw : LIMIT_DEFAULT;
  };

  const getBoxVariantId = (limit) => {
    if (limit === 4) return SLICES_BOX_4_VARIANT_ID;
    if (limit === 6) return SLICES_BOX_6_VARIANT_ID;
    if (limit === 12) return SLICES_BOX_12_VARIANT_ID;
    return SLICES_BOX_6_VARIANT_ID;
  };

  async function fetchCollectionProducts(handle) {
    const url = `/collections/${handle}/products.json?limit=250`;
    const res = await fetch(url, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error(`Failed to fetch ${url}`);
    const data = await res.json();
    return (data.products || []);
  }

  function firstVariant(product) {
    return (product.variants || [])[0] || null;
  }

  function imgOf(p) {
    return (p.images && p.images[0] && p.images[0].src) ? p.images[0].src : '';
  }

  // ✅ Reliable: add ONE product (the box) with properties
  function addBoxToCartViaForm(boxVariantId, properties) {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = '/cart/add';
    form.style.display = 'none';

    const id = document.createElement('input');
    id.type = 'hidden';
    id.name = 'id';
    id.value = String(boxVariantId);
    form.appendChild(id);

    const qty = document.createElement('input');
    qty.type = 'hidden';
    qty.name = 'quantity';
    qty.value = '1';
    form.appendChild(qty);

    Object.entries(properties || {}).forEach(([k, v]) => {
      const inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = `properties[${k}]`;
      inp.value = String(v);
      form.appendChild(inp);
    });

    document.body.appendChild(form);
    form.submit();
  }

  async function init() {
    const root = document.querySelector('.smb-builder[data-builder="slices"]');
    if (!root) return;

    // ✅ FIX DESKTOP: move sticky to <body> so theme transforms can't break fixed
    const sticky = document.getElementById('smb-sticky');
    if (sticky && sticky.parentElement !== document.body) {
      document.body.appendChild(sticky);
    }

    const limit = getBoxLimit();
    const boxVariantId = getBoxVariantId(limit);

    const selectedEl = $('#smb-selected');
    const limitEl = $('#smb-limit');
    const selectedEl2 = $('#smb-selected-2');
    const limitEl2 = $('#smb-limit-2');

    const flavorsWrap = $('#smb-flavors');
    const boxInner = $('#smb-box-inner');
    const addBtn = $('#smb-add');

    const wm = $('#smb-wm');
    const err = $('#smb-error');
    const stickySub = $('#smb-sticky-sub');

    if (!selectedEl || !limitEl || !flavorsWrap || !boxInner || !addBtn) return;

    limitEl.textContent = String(limit);
    if (limitEl2) limitEl2.textContent = String(limit);

    const showError = (msg) => { err.style.display = ''; err.textContent = msg; };
    const clearError = () => { err.style.display = 'none'; err.textContent = ''; };

    let slices = [];
    const byId = new Map();  // productId -> product
    const state = new Map(); // productId -> qty

    const selectedCount = () => {
      let sum = 0;
      for (const q of state.values()) sum += q;
      return sum;
    };

    function applyBoxGrid() {
      let cols = 3;
      if (limit === 4) cols = 2;
      if (limit === 12) cols = 4;

      boxInner.style.display = 'grid';
      boxInner.style.gridTemplateColumns = `repeat(${cols}, minmax(0, 1fr))`;
      boxInner.style.gap = '0px';
      boxInner.style.alignContent = 'start';
    }

    function buildSelectedFlat() {
      const out = [];
      for (const [pid, qty] of state.entries()) {
        const p = byId.get(String(pid));
        if (!p) continue;
        const img = imgOf(p);
        for (let i = 0; i < qty; i++) out.push({ title: p.title, img });
      }
      return out;
    }

    function renderBoxPreview() {
      applyBoxGrid();

      // keep watermark
      const wmNode = document.getElementById('smb-wm');
      boxInner.innerHTML = '';
      if (wmNode) boxInner.appendChild(wmNode);

      const total = selectedCount();

      if (total === 0) {
        if (wmNode) wmNode.classList.remove('is-hidden');
        return;
      }
      if (wmNode) wmNode.classList.add('is-hidden');

      const flat = buildSelectedFlat();
      flat.slice(0, limit).forEach((it, idx) => {
        const slot = el('div', { class: 'smb-slot', title: it.title }, [
          it.img ? el('img', { src: it.img, alt: it.title, loading: 'lazy' }) : el('span', { html: '🍰' })
        ]);
        slot.appendChild(el('span', { class: 'smb-badge', html: String(idx + 1) }));
        boxInner.appendChild(slot);
      });
    }

    function syncCounters() {
      const total = selectedCount();
      selectedEl.textContent = String(total);
      if (selectedEl2) selectedEl2.textContent = String(total);
    }

    function updateAddButton() {
      const total = selectedCount();
      const ok = total === limit;
      addBtn.disabled = !ok;

      if (stickySub) {
        stickySub.textContent = ok
          ? 'Klaar! Je kunt toevoegen aan je winkelwagen.'
          : 'Vul de box om “In winkelwagen” te ontgrendelen.';
      }
    }

    function updateUI() {
      syncCounters();
      updateAddButton();
      renderBoxPreview();
    }

    function renderFlavors() {
      flavorsWrap.innerHTML = '';
      if (!slices.length) {
        flavorsWrap.textContent = 'Geen smaken gevonden in deze collectie.';
        return;
      }

      slices.forEach((p) => {
        const v = firstVariant(p);
        if (!v) return;

        const pid = String(p.id);
        const imgUrl = imgOf(p);
        const qty = state.get(pid) || 0;

        const minus = el('button', { type: 'button', 'data-action':'minus', 'data-pid': pid });
        minus.textContent = '−';
        minus.disabled = qty === 0;

        const plus = el('button', { type: 'button', 'data-action':'plus', 'data-pid': pid });
        plus.textContent = '+';
        plus.disabled = selectedCount() >= limit;

        const qtyEl = el('span', { html: String(qty) });
        const qtyWrap = el('div', { class: 'smbQty' }, [minus, qtyEl, plus]);

        const row = el('div', { class: 'smbRow', 'data-pid': pid }, [
          el('img', { src: imgUrl, alt: p.title, loading: 'lazy' }),
          el('div', {}, [
            el('p', { class: 'smbRow__title', html: p.title }),
            el('p', { class: 'smbRow__sub', html: 'Tik op + om toe te voegen' })
          ]),
          qtyWrap
        ]);

        flavorsWrap.appendChild(row);
      });
    }

    // Delegation for +/- (fast + clean)
    flavorsWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-action][data-pid]');
      if (!btn) return;

      clearError();

      const pid = btn.getAttribute('data-pid');
      const action = btn.getAttribute('data-action');
      const cur = state.get(pid) || 0;

      if (action === 'minus') {
        const next = cur - 1;
        if (next <= 0) state.delete(pid);
        else state.set(pid, next);
      }

      if (action === 'plus') {
        if (selectedCount() >= limit) return;
        state.set(pid, cur + 1);
      }

      renderFlavors();
      updateUI();
    });

    addBtn.addEventListener('click', () => {
      clearError();

      const total = selectedCount();
      if (total !== limit) return;

      const properties = { box_type: 'slices', box_size: String(limit) };

      let i = 1;
      const flavorsSummary = [];
      for (const [pid, qty] of state.entries()) {
        const p = byId.get(String(pid));
        if (!p || !qty) continue;
        const label = `${p.title} (${qty})`;
        properties[`flavor_${i}`] = label;
        flavorsSummary.push(label);
        i++;
      }
      properties.flavors = flavorsSummary.join(', ');

      addBtn.disabled = true;
      addBtn.textContent = 'Toevoegen…';

      addBoxToCartViaForm(boxVariantId, properties);
    });

    try {
      slices = await fetchCollectionProducts(SLICES_COLLECTION);
      slices.forEach(p => byId.set(String(p.id), p));

      renderFlavors();
      updateUI();
    } catch (e) {
      console.error(e);
      showError('Kon smaken niet laden.');
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
